module.exports = __webpack_public_path__ + "img/Feature-7.fd053a6.svg";